import { createContext, useContext, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const LandmarkRefsContext = createContext({});

export const useLandmarkRefsContext = () => useContext(LandmarkRefsContext);

const LandmarkRefsProvider = ({ children }: any) => {
    // @ts-expect-error TS2554: Expected 1 arguments, but got 0.
    const pageHeadingRef = useRef();
    // @ts-expect-error TS2554: Expected 1 arguments, but got 0.
    const formErrorsRef = useRef();
    const [fieldErrors, setFieldErrors] = useState({});
    const [displayFormErrors, setDisplayFormErrors] = useState(false);
    const [submitAttempted, setSubmitAttempted] = useState(false);

    const setPageHeadingRef = (newPageHeadingRef: any) => {
        if (newPageHeadingRef?.current) {
            pageHeadingRef.current = newPageHeadingRef.current;
        }
    };

    const registerFieldError = ({ id, errorMessage, fieldContainerRef, fieldRef }: any) => {
        setFieldErrors((prevState) => ({
            ...prevState,
            [id]: {
                reference: fieldRef,
                fieldContainerRef,
                message: errorMessage
            }
        }));
    };

    const unregisterFieldError = ({ id }: any) => {
        setFieldErrors((prevState) => {
            const newState = {
                ...prevState
            };
            // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type ''
            delete newState[id];
            return newState;
        });
    };

    return (
        <LandmarkRefsContext.Provider
            value={{
                pageHeadingRef,
                setPageHeadingRef,
                formErrorsRef,
                registerFieldError,
                unregisterFieldError,
                fieldErrors,
                displayFormErrors,
                setDisplayFormErrors,
                submitAttempted,
                setSubmitAttempted
            }}
        >
            {children}
        </LandmarkRefsContext.Provider>
    );
};

LandmarkRefsProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export default LandmarkRefsProvider;
